"use client";
/**
 * Generate a secure random string using the browser crypto functions
 *
 * @returns {string} -
 */
function generateRandomString() {
    const array = new Uint32Array(28);
    window.crypto.getRandomValues(array);
    return Array.from(array, (dec) => ("0" + dec.toString(16)).substr(-2)).join("");
}
/**
 * Calculate the SHA256 hash of the input text.
 * Returns a promise that resolves to an ArrayBuffer
 *
 * @param {string} plain -
 * @returns {PromiseLike<string>} -
 */
function sha256(plain) {
    const encoder = new TextEncoder();
    const data = encoder.encode(plain);
    return window.crypto.subtle.digest("SHA-256", data).then((result) => {
        return String.fromCharCode(...new Uint8Array(result));
    });
}
/**
 * Base64-urlEncodes the input string
 *
 * @param {string} str -
 * @returns {string} -
 */
function base64urlencode(str) {
    // Encode str using base64.
    // Then convert the base64 encoded to base64url encoded
    //   (replace + with -, replace / with _, trim trailing =)
    return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
/**
 * Return the base64-urlencoded sha256 hash for the PKCE challenge
 *
 * @param v
 * @returns {Promise<string>}
 */
async function pkceChallengeFromVerifier(v) {
    const hashed = await sha256(v);
    return base64urlencode(hashed);
}
export { generateRandomString, sha256, base64urlencode, pkceChallengeFromVerifier };
//# sourceMappingURL=crypto.js.map